export const regExpressions = {
	date: '(([1-2][0-9])|([0-9])|(3[0-1])){2}-((1[0-2])|([0-9])){2}-[0-9]{4}',
	academic_year: '^([0-9]){2}/([0-9]){2}',
	only_number: /^\d+$/,
	only_number_decimal: /^\d+(\.\d?)?$/,
}
